import { css } from '@emotion/core';
import Badge from '@material-ui/core/Badge';
import { promo500 } from 'Mui/styles/color';

/**
 * @method withBadge - MUI Badge HOC Function
 * @param {Object}  props
 * @param {String}  props.badgeColor     - Badge 的背景顏色
 * @param {String}  props.badgeVariant   - Badge 的類型 dot (沒顯示數字只有點) | standard (顯示數字)
 * @param {Number}  props.badgeCount     - Badge 顯示的數字 or 文字 (預設 0 會不顯示)
 * @param {Number}  props.badgeMaxCount  - Badge 能顯示的顯示的最大數字
 * @param {String}  props.badgePlacement - Badge 的位置 top-right | top-left | bottom-right | bottom-left
 * @param {Boolean} props.badgeInvisible - Badge 的顯示邏輯 (預設是 badgeCount 小於等於 0 會不顯示)
 * @param {String}  props.badgeOverlap   - Badge 包住的重疊形狀應要是該形狀。
 * @param {Object}  props.badgeStyle     - Badge 的 custom style
 * @returns {JSX.Element}
 */

function withBadge(Component) {
    const BadgeHOC = props => {
        const {
            badgeColor = promo500.color,
            badgeVariant = 'standard',
            badgeCount,
            badgeMaxCount = 999,
            badgePlacement = 'top-right',
            badgeInvisible = badgeCount <= 0,
            badgeOverlap = 'circular',
            badgeStyle,
            ...others
        } = props;
        const vertical = badgePlacement.split('-')[0] || 'top';
        const horizontal = badgePlacement.split('-')[1] || 'right';
        return (
            <Badge
                color="secondary"
                badgeContent={badgeCount}
                variant={badgeVariant}
                invisible={badgeInvisible}
                max={badgeMaxCount}
                anchorOrigin={{
                    vertical,
                    horizontal
                }}
                css={[badgeBaseStyle(badgeColor, badgeVariant), badgeStyle]}
                overlap={badgeOverlap}
            >
                <Component {...others} />
            </Badge>
        );
    };
    return BadgeHOC;
}

export default withBadge;

const badgeBaseStyle = (bgColor, badgeVariant) => css`
    & .MuiBadge-badge {
        ${
            badgeVariant === 'standard' &&
            `
            min-width: 17px;
            min-height: 17px;
            width: fit-content;
            height: 17px;
            font-family: Roboto;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            letter-spacing: 0.4px;
        `
        }
        background-color: ${bgColor};
`;
